export default [
  // 客服中心(列表)
  {
    path: '/baibu-task/customer-center/list',
    name: 'baibuTaskCustomerCenterList',
    component: () => import(/* webpackChunkName: 'baibuTaskCustomerCenterList' */ '@/views/baibu-task/customer-center/list.vue'),
  },
  // 客服中心(评价/追评)
  {
    path: '/baibu-task/customer-center/submit-valuation/:id',
    name: 'baibuTaskCustomerCenterSubmitValuation',
    component: () => import(/* webpackChunkName: 'baibuTaskCustomerCenterSubmitValuation' */ '@/views/baibu-task/customer-center/submit-valuation.vue'),
  },
  // 客服中心(操作页)
  {
    path: '/baibu-task/customer-operate',
    name: 'baibuTaskCustomerOperate',
    component: () => import(/* webpackChunkName: 'baibuTaskCustomerOperate' */ '@/views/baibu-task/customer-operate/index.vue'),
  },
  // 客服中心(客服聊天页)
  {
    path: '/baibu-task/customer-detail/:id',
    name: 'baibuTaskCustomerDetail',
    component: () => import(/* webpackChunkName: 'baibuTaskCustomerDetail' */ '@/views/baibu-task/customer-detail/index.vue'),
  },
];
